import keyIcon from 'images/coviant/key_1.gif';
import publicKeyIcon from 'images/coviant/key_2.gif';
import externalPartnerIcon from 'images/coviant/Partner_1.gif';
import internalPartnerIcon from 'images/coviant/Partner_2.gif';
import sshIcon from 'images/coviant/sshkey.gif';
import sshPublicIcon from 'images/coviant/sshpublickey.png';

import sslIcon from 'images/coviant/sslcert.gif';
import sslClientIcon from 'images/coviant/ssl_client_cert.gif';
import inboundTransactionIcon from 'images/coviant/Trans_1.gif';
import outboundTransactionIcon from 'images/coviant/Trans_2.gif';
import sftpUserIcon from 'images/person_black_24dp.svg';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';

export const IconMap: Partial<Record<DiplomatObjectTypeUnion, string>> = {
   KEY_PAIR: keyIcon,
   PUBLIC_KEY: publicKeyIcon,
   SSH_KEY: sshIcon,
   SSH_PUBLIC_KEY: sshPublicIcon,
   SSL_CERTIFICATE: sslIcon,
   SSL_CLIENT_CERTIFICATE: sslClientIcon,
   EXTERNAL_PARTNER: externalPartnerIcon,
   INTERNAL_PARTNER: internalPartnerIcon,
   INBOUND_TRANSACTION: inboundTransactionIcon,
   OUTBOUND_TRANSACTION: outboundTransactionIcon,
   SYNCHRONIZATION: outboundTransactionIcon,
   SFTP_USER: sftpUserIcon,
};
